// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, maybe, objectOf, recordOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isEngagementLinkTemplatesUpdateTagsResult = objectOf({
  info: string,
  undo_identifier: maybe(number),
  undo_data: objectOf({
    desired_state: recordOf({
      key: string,
      value: arrayOf(string),
    }),
  }),
  all_tags: arrayOf(string),
  used_tags: arrayOf(string),
});
